import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpInterceptor } from '../shared/index';
import { CONSTANT_VALUES } from '../constants/constant-values';
import { environment } from '../../environments/environment';
//import { Feed } from './feed';
import { Http, Response } from '@angular/http';

@Injectable()
export class FeedService {
    constructor(private http: HttpInterceptor) {
    }
    /**
     * Send message to member either broadcast or alert
     *
     * @param {any} feedObj
     * @returns
     *
     * @memberOf FeedService
     */
    sendFeed(feedObj) {
        let url = CONSTANT_VALUES.URL_CREATE_FEED;
        return new Promise((resolve, reject) => {
            this.http.post(url, feedObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
    /**
     * Get feed list for specific vendor
     *
     * @param {any} feedObj
     * @returns
     *
     * @memberOf FeedService
     */
    getFeedByVendor(feedObj) {
        let url = CONSTANT_VALUES.URL_GET_FEDD_HISTORY;
        return new Promise((resolve, reject) => {
            this.http.post(url, feedObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }


    editVendorInfo(vendorObj) {
        let url = CONSTANT_VALUES.VENDOR_EDIT;
        return new Promise((resolve, reject) => {
            this.http.post(url, vendorObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    /**
     * Redirect to feed page
     *
     * @param {any} that
     *
     * @memberOf FeedService
     */
    goToFeed(that) {
        try {
            if (localStorage.getItem('vendor')) {
                that.router.navigate(['/feed']);
            }
        } catch (err) {
            console.log(err);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/feed/feed.service.ts